<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

           <template v-if="loading">
                <div class="m-2">
                <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img src="img/no-image/user.png" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">

                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">1</span>
                                            <span class="description">Info X</span>
                                        </div>
                                        <div>
                                            <span class="heading">2</span>
                                            <span class="description">Info Y</span>
                                        </div>
                                        <div>
                                            <span class="heading">3</span>
                                            <span class="description">Info Z</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    {{model.nomeFantasia}}
                                </h3 >
                                <div class="h5 mt-4">
                                    <span class="font-weight-normal">Cadastro desde: </span>{{ formatarData(model.created_at) }}
                                </div>
                                <hr class="my-4" />
                                 <div class="gray-300" style="background-color: #f6f9fc; padding: 20px; ">
                                        <base-input alternative=""
                                                    label="Atualizar Senha"
                                                    input-classes="form-control-alternative"
                                                    v-model="model.senha"
                                                    placeholder="Em branco, para manter a mesma"
                                        />

                                </div>

                                <div class="mt-4">
                                  <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>

                                </div>

                                 <div class="mt-4">
                                    <div v-if="hasError" style="border: 2px solid #d83a3a; color: #d83a3a; border-radius: 5px; padding: 10px; text-transform: uppercase; font-size: 12px">
                                        Houve um erro ao salvar o usuário! Verifique os campos.
                                    </div>

                                     <div v-if="hasSuccess" style="border: 2px solid #4fbf1b; color: #4fbf1b; border-radius: 5px; padding: 10px; text-transform: uppercase; font-size: 12px">
                                        Usuário salvo com sucesso!
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Detalhes de Usuário</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Informações Gerais</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="Laborátorio"
                                                        input-classes="form-control-alternative"
                                                        v-model="lab.nome"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8">
                                            <base-input alternative=""
                                                        label="Nome Completo"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.nomeCompleto"
                                            />
                                        </div>
                                    </div>
                                     <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="E-mail de Acesso"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.email"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <hr class="my-4 mb-4" />
                                <h6 class="heading-small text-muted mb-4">Dados PIX</h6>
                                

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group has-label"> 
                                                <label class="form-control-label"> 
                                                   Tipo PIX
                                                </label>
   
                                                  <v-select 
                                                        :options="pix_tipos" 
                                                        label="nome"
                                                        class="form-control-alternative"
                                                        v-model="model.pix_tipo"
                                                        >
                                                            <template #option="option">
                                                                {{ option.nome }}
                                                            </template>
                                                  </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Chave PIX"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.pix_chave"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <hr class="my-4 mb-6" />

                                <div v-if="isNew == false" class="text-center">
                                    <base-button
                                        type="danger"
                                        @click="excluir()"
                                        v-html="txt2"
                                        ></base-button>
                                </div>
                            
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import usuarios from '@/cflow/proteticos.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  import storage from 'storage';
  import router from '@/router'
  export default {
    name: 'tables',
    components: {
      //Multiselect,
      BaseButton,
      BaseInput,
      vSelect
    },
    
    methods: {
        salvar: function() {
            const _this = this;
            let form = _this.model;
            let id = _this.id;

            _this.loading = true;

            let pix_tipo = form.pix_tipo;
            if(pix_tipo && pix_tipo.nome) {
                pix_tipo = pix_tipo.nome;
                form.pix_tipo = pix_tipo;
            }

            usuarios.salvar(id, form).then(() => {
                _this.loading = false;
                router.push('/usuarios-proteticos');
                
            }).catch(() => {
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });
        },

        excluir: function() {
            const _this = this;
            const _id = this.$route.params.id;
            if(!_id) return;

            _this.loading = true;
            usuarios.excluir(_id).then(() => {
                 setTimeout(function(){
                    router.push('/usuarios-proteticos/');
                    _this.loading = false;
                },1000);
            }).catch((error) => {
                console.err('ERROR', error)
            });
        }
    },
    data() {
      return {
        txt1: 'Salvar Protético',
        txt2: 'Excluir Usuário',
        id: null,
        hasSuccess: false,
        hasError: false,
        loading: false,
        isNew: true,
        lab: {},
        model: {
          id: '',
          lab_id: '',
          nomeCompleto: '',
          email: '',
          senha: '',
          pix_tipo: '',
          pix_chave: ''
        },
        pix_tipos: [{'nome':'CPF'}, {'nome':'E-mail'}, {'nome':'Celular'}, {'nome':'Chave Aleatória'}]
        //pix_tipos: ['Teste']
      }
    },
    
     mounted(){
      //this.initLoad(0, 0);

      var user = storage.get("user");
      this.lab = user;

      const _id = this.$route.params.id;
      if(!_id) return;

      this.id = _id;
      this.loading = true;

    usuarios.detalhes(_id).then((res) => {
        this.isNew = false;
        this.model = res;
        this.model.pix_tipo = { nome: res.pix_tipo }
        this.loading = false;
    });

    }
  };
</script>
<style>
.select {
    width: 100%;
    padding: 5px 5px;
}
</style>
